import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import { IParameter } from '@/pages/Parameters/parameters.types.ts'
import { useCallback, useId, useMemo, useState } from 'react'
import { useRecoilValue } from 'recoil'
import parametersSelectors from '../../../pages/Parameters/parameters.selectors.ts'
import useLastValuesRef from '@/services/data/hooks/useLastValuesRef.ts'

const useParameterValue = (equipmentId: IEquipment['id'], sourceId: IParameter['sourceId']) => {
  const dataSubscriptionId = useId()
  const sourceIdToParameterIdMap = useRecoilValue(parametersSelectors.getSourceIdToIdMap)
  const [value, setValue] = useState(null)

  const handleNewValueReceived = useCallback(() => {
    setValue(lastValues.ref.current[equipmentId][sourceIdToParameterIdMap[sourceId]] ?? 0)
  }, [equipmentId, sourceId])

  const config = useMemo(() => {
    return {
      live: true,
      parameters: [sourceIdToParameterIdMap[sourceId]],
      devices: [equipmentId],
      id: dataSubscriptionId,
      tsFrom: Date.now() - 5000,
      onNewValueReceived: handleNewValueReceived,
    }
  }, [equipmentId, sourceId])

  const lastValues = useLastValuesRef(config)

  return {
    loading: value === null,
    value,
  }
}

export default useParameterValue
